<script setup lang="ts">
import { ref, onMounted } from 'vue';
import Image from '@/mixit-ui/components/media/Image.vue';
import ItemCategory from '../list-item/ItemCategory.vue';
import { categoryService, type ProductCategory } from '@/services-new/categoryService';

import categoriesPlaceholderBanner from '@/assets/example-media/categories-placeholder.jpg?w=434;868&format=avif;webp;jpg&as=picture';

defineProps<{ maxHeight?: string }>()

const categories = ref<ProductCategory[]>([])

onMounted(async () => {
  categories.value = await categoryService.loadProductsCategories()
})
</script>

<template>
  <div
    class="grid grid-cols-4 bg-white rounded-b-lg shadow p-10 border-t-1 border-brown-200 gap-x-8 gap-y-6 text-brown-600 overflow-y-auto"
    :style="maxHeight ? { maxHeight } : {}"
  >
    <div
      v-for="category in categories"
      :key="category.systemName"
      class="flex flex-col gap-4"
    >
      <ItemCategory
        :label="category.title"
        :image-uri="category.image"
        :router-to="{ name: 'productsPath', params: { permalink: category.permalink } }"
        severity="yellow"
      />
      <ul>
        <li
          v-for="child in category.subcategories"
          :key="child.systemName"
        >
          <RouterLink
            :to="{ name: 'productsPath', params: { permalink: child.permalink } }"
            class="flex gap-1 flex-row intems-center font-bold font-roboto-slab group"
          >
            <i class="mi-chevron-r transition group-hover:translate-x-1" /><span>{{ child.title }}</span>
          </RouterLink>
        </li>
      </ul>
    </div>
    <div class="row-start-1 row-end-4 col-start-4 col-end-5">
      <div class="rounded-sm overflow-hidden">
        <Image :image="categoriesPlaceholderBanner" />
      </div>
    </div>
  </div>
</template>
